<template>
  <div class="about-me">
    <b-container class="bv-example-row">
      <div class="about-me-header">
        <h1>
          About Me
        </h1>
        <div data-aos="zoom-in-up">
          <p>
            I am <span class="keywords">passionate about what I do</span>, for
            me being a coder is more than a job
            <span class="keywords">for me it is a lifestyle.</span> The true
            fact about this life it help you grow daily, due to the challenge we
            face on a daily basis, making me a better
            <span class="keywords">person</span> and
            <span class="keywords">coder</span>.
          </p>
          <p>This are my <span class="keywords">Tech Stack</span></p>
        </div>
      </div>
      <div class="about-me-header">
        <h2>
          Development Tecnologies
        </h2>
        <div class="tecnologies-languages">
          <b-row>
            <b-col cols="4">
              <div>
                <h3>
                  Programming Languages
                </h3>
                <b-table-simple
                  borderless
                  stacked
                  class="development-tecnologies-table"
                >
                  <b-tbody>
                    <b-tr>
                      <b-td data-aos="zoom-in-down"
                        ><b-img
                          :src="jsImage"
                          fluid
                          alt="Responsive image"
                        ></b-img
                        ><br />
                        JavaScript</b-td
                      >
                      <b-td data-aos="zoom-in-down"
                        ><b-img
                          :src="rubyImage"
                          fluid
                          alt="Responsive image"
                        ></b-img>
                        <br />
                        Ruby</b-td
                      >
                      <b-td data-aos="zoom-in-down"
                        ><b-img
                          :src="tsImage"
                          fluid
                          alt="Responsive image"
                        ></b-img>
                        <br />TypeScript</b-td
                      >

                      <b-td data-aos="zoom-in-down"
                        ><b-img
                          :src="cppImage"
                          fluid
                          alt="Responsive image"
                        ></b-img>
                        <br />C++</b-td
                      >
                      <b-td data-aos="zoom-in-down"
                        ><b-img
                          :src="pythonImage"
                          fluid
                          alt="Responsive image"
                        ></b-img>
                        <br />Python</b-td
                      >
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </div>
            </b-col>
            <b-col cols="4">
              <div>
                <h3>
                  Front-End Framework
                </h3>
                <b-table-simple
                  borderless
                  stacked
                  class="development-tecnologies-table"
                >
                  <b-tbody>
                    <b-tr>
                      <b-td data-aos="zoom-in-down"
                        ><b-img
                          :src="reactImage"
                          fluid
                          alt="Responsive image"
                        ></b-img>
                        <br />React</b-td
                      >
                      <b-td data-aos="zoom-in-down"
                        ><b-img
                          :src="vueImage"
                          fluid
                          alt="Responsive image"
                        ></b-img
                        ><br />Vue</b-td
                      >
                      <b-td class="small-image" data-aos="zoom-in-down"
                        ><b-img
                          :src="emberImage"
                          fluid
                          alt="Responsive image"
                        ></b-img
                        ><br /><span class="learning-indicator">Ember</span>
                        <br />
                      </b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </div>
            </b-col>
            <b-col cols="4">
              <div>
                <h3>
                  Back-End Framework
                </h3>
                <b-table-simple
                  borderless
                  stacked
                  class="development-tecnologies-table backend"
                >
                  <b-tbody>
                    <b-tr>
                      <b-td data-aos="zoom-in-down"
                        ><b-img
                          :src="expressImage"
                          fluid
                          alt="Responsive image"
                        ></b-img
                        ><br />NodeJs</b-td
                      >
                      <b-td data-aos="zoom-in-down"
                        ><b-img
                          :src="rubyOnRailsImage"
                          fluid
                          alt="Responsive image"
                        ></b-img
                        ><br />Ruby on Rails</b-td
                      >
                      <b-td data-aos="zoom-in-down"
                        ><b-img
                          :src="djangoImage"
                          fluid
                          alt="Responsive image"
                        ></b-img
                        ><br />
                        <span class="learning-indicator">Django</span>
                      </b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4">
              <div>
                <h3>
                  Cross-platform
                </h3>
                <b-table-simple
                  borderless
                  stacked
                  class="development-tecnologies-table"
                >
                  <b-tbody>
                    <b-tr>
                      <b-td data-aos="zoom-in-down"
                        ><b-img
                          :src="reactImage"
                          fluid
                          alt="Responsive image"
                        ></b-img
                        ><br />React Native</b-td
                      >
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="database">
                <h3>
                  Database
                </h3>
                <b-table-simple
                  borderless
                  stacked
                  class="development-tecnologies-table"
                >
                  <b-tbody>
                    <b-tr>
                      <b-td data-aos="zoom-in-down"
                        ><b-img
                          :src="mySqlImage"
                          fluid
                          alt="Responsive image"
                        ></b-img
                        ><br />MySQL</b-td
                      >
                      <b-td data-aos="zoom-in-down"
                        ><b-img
                          :src="postgresSQLImage"
                          fluid
                          alt="Responsive image"
                        ></b-img
                        ><br />PostresSQL</b-td
                      >
                      <b-td data-aos="zoom-in-down"
                        ><b-img
                          :src="mongodbImage"
                          fluid
                          alt="Responsive image"
                        ></b-img
                        ><br />MongoDB</b-td
                      >
                      <b-td data-aos="zoom-in-down"
                        ><b-img
                          :src="apacheCouchdbImage"
                          fluid
                          alt="Responsive image"
                        ></b-img
                        ><br />Apache Couchdb</b-td
                      >
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </div>
            </b-col>
            <b-col cols="4">
              <div>
                <h3>
                  Others
                </h3>
                <b-table-simple
                  borderless
                  stacked
                  class="development-tecnologies-table"
                >
                  <b-tbody>
                    <b-tr>
                      <b-td class="small-image" data-aos="zoom-in-down"
                        ><b-img
                          :src="awsImage"
                          fluid
                          alt="Responsive image"
                        ></b-img
                        ><br />AWS</b-td
                      >

                      <b-td data-aos="zoom-in-down"
                        ><b-img
                          :src="reduxLogo"
                          fluid
                          alt="Responsive image"
                        ></b-img
                        ><br />Redux</b-td
                      >
                      <b-td data-aos="zoom-in-down"
                        ><b-img
                          :src="vueImage"
                          fluid
                          alt="Responsive image"
                        ></b-img
                        ><br />Vuex</b-td
                      >
                      <b-td data-aos="zoom-in-down"
                        ><b-img
                          :src="bootstrapLogo"
                          fluid
                          class="bootstrap-image"
                          alt="Responsive image"
                        ></b-img
                        ><br />Bootstrap</b-td
                      >
                      <b-td data-aos="zoom-in-down"
                        ><b-img
                          :src="gitLogo"
                          fluid
                          alt="Responsive image"
                        ></b-img
                        ><br />Git</b-td
                      >
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
//programming languages images
import jsLogo from "../assets/tecnologies-logos/js-logo.png";
import rubyLogo from "../assets/tecnologies-logos/ruby-logo.png";
import tsLogo from "../assets/tecnologies-logos/ts-logo.png";
import pythonLogo from "../assets/tecnologies-logos/python-logo.png";
import cppLogo from "../assets/tecnologies-logos/c++logo.png";
//front-end framework images
import reactLogo from "../assets/tecnologies-logos/react-logo.png";
import vueLogo from "../assets/tecnologies-logos/vue-logo.png";
import emberLogo from "../assets/tecnologies-logos/ember-logo.png";

//back-end framework images
import expressLogo from "../assets/tecnologies-logos/express-nodejs-logo.png";
import rubyOnRailsLogo from "../assets/tecnologies-logos/rubyonrails-logo.png";
import djangoLogo from "../assets/tecnologies-logos/django-logo.png";

//databaseframework images
import mongodbLogo from "../assets/tecnologies-logos/mongodb-logo.png";
import mySqlLogo from "../assets/tecnologies-logos/mysql-logo.png";
import postgresSQLLogo from "../assets/tecnologies-logos/postgres-sql-logo.png";
import apacheCouchdbLogo from "../assets/tecnologies-logos/apache-couchdb-logo.png";

//cross-platfrom
//others
import reduxLogo from "../assets/tecnologies-logos/redux-logo.png";
import gitLogo from "../assets/tecnologies-logos/git-logo.png";
import bootstrapLogo from "../assets/tecnologies-logos/bootstrap-logo.png";
import awsLogo from "../assets/tecnologies-logos/aws-logo.png";

export default {
  data() {
    return {
      //programming languages images
      jsImage: jsLogo,
      rubyImage: rubyLogo,
      tsImage: tsLogo,
      pythonImage: pythonLogo,
      cppImage: cppLogo,
      //front-end framework images
      reactImage: reactLogo,
      vueImage: vueLogo,
      emberImage: emberLogo,
      //back-end framework images
      expressImage: expressLogo,
      rubyOnRailsImage: rubyOnRailsLogo,
      djangoImage: djangoLogo,
      //database images
      mongodbImage: mongodbLogo,
      mySqlImage: mySqlLogo,
      apacheCouchdbImage: apacheCouchdbLogo,
      postgresSQLImage: postgresSQLLogo,
      //cross-platform
      //others
      gitLogo: gitLogo,
      reduxLogo: reduxLogo,
      bootstrapLogo: bootstrapLogo,
      awsImage: awsLogo,
    };
  },
};
</script>

<style>
.about-me-header {
  padding: 5%;
}
.about-me-header h1 {
  color: #ffbb00 !important;
  font-size: 4vw !important;
  text-shadow: 4px 4px #000000;
  letter-spacing: 1px;
  font-weight: bold;
  padding: 5px;
}
.about-me-header h2 {
  color: #ffbb00 !important;
  text-shadow: 3px 3px #000000;
  text-align: left;
  font-size: 3vw;
  font-weight: bolder;
  padding: 5px;
}
.about-me-header h3 {
  color: #ffbb00 !important;
  text-shadow: 3px 3px #000000;
  text-align: left;
  font-size: 2vw;
  font-weight: bolder;
  padding: 5px;
}
.about-me-header p {
  color: #a8a9ad !important;
  text-shadow: 3px 3px #000000;
  text-align: left;
  font-size: 2vw;
  font-weight: bolder;
  padding: 5px;
}

.development-tecnologies-table {
  color: #a8a9ad !important;
  text-align: center;
  font-size: 1.6vw !important;
  font-weight: bold;
  width: 80% !important;
  margin: auto;
  border-radius: 15px;
  border-color: transparent !important;
  letter-spacing: 1px !important;
  text-shadow: 3px 3px #000000;
}
.development-tecnologies-table img {
  width: 5vw !important;
}

.tecnologies-languages h3 {
  text-align: center;
  font-size: 2vw;
}
.tecnologies-languages div {
  padding: 5px;
}
.backend img {
  width: 9vw !important;
}
.database img {
  width: 5vw !important;
}
.bootstrap-image {
  border-radius: 10px !important;
}
.small-image img {
  width: 8vw !important;
}
.learning-indicator {
  color: #ffbb00 !important;
}
/*****************************************************/
/*****************************************************/
@media only screen and (max-width: 1032px) {
  .about-me-header h1 {
    font-size: 5vw !important;
  }
  .about-me-header h2 {
    font-size: 3.5vw;
  }

  .about-me-header p {
    font-size: 3vw;
  }
  .development-tecnologies-table {
    font-size: 3vw !important;
  }
  .development-tecnologies-table img {
    width: 7vw !important;
  }
  .tecnologies-languages h3 {
    font-size: 3vw !important;
  }
  .tecnologies-languages div {
    padding: 1px;
  }
  .backend img {
    width: 12vw !important;
  }
  .database img {
    width: 9vw !important;
  }
  .small-image img {
    width: 10vw !important;
  }
}
/* Small phones to small tablets: from 481 to 767*/
@media only screen and (max-width: 767px) {
  .about-me-header h1 {
    font-size: 7vw !important;
  }
  .about-me-header h2 {
    font-size: 6vw;
  }
  .about-me-header h3 {
    color: #ffbb00 !important;
    text-shadow: 2px 2px #000000;
    text-align: left;
    font-size: 2vw;
    font-weight: bolder;
    padding: 5px;
  }
  .about-me-header p {
    font-size: 4vw;
  }
  .development-tecnologies-table {
    font-size: 4vw !important;
    width: 100% !important;
    letter-spacing: 0.5px !important;
  }
  .development-tecnologies-table img {
    width: 13vw !important;
    padding: 5px;
  }
  .tecnologies-languages h3 {
    text-align: center;
    font-size: 4vw !important;
  }
  .tecnologies-languages div {
    padding: 1px;
  }
  .backend img {
    width: 20vw !important;
  }
  .database img {
    width: 13vw !important;
  }
  .small-image img {
    width: 16vw !important;
  }
}

/*Small Phone from 0 to 480px*/
@media only screen and (max-width: 400px) {
  .about-me-header h1 {
    font-size: 7vw !important;
  }
  .about-me-header h2 {
    font-size: 6vw;
  }
  .about-me-header h3 {
    color: #ffbb00 !important;
    text-shadow: 2px 2px #000000;
    text-align: left;
    font-size: 2vw;
    font-weight: bolder;
    padding: 5px;
  }
  .about-me-header p {
    font-size: 4vw;
  }
  .development-tecnologies-table {
    font-size: 4vw !important;
    width: 100% !important;
    letter-spacing: 0.5px !important;
  }
  .development-tecnologies-table img {
    width: 13vw !important;
    padding: 5px;
  }
  .tecnologies-languages h3 {
    text-align: center;
    font-size: 4vw !important;
  }
  .tecnologies-languages div {
    padding: 1px;
  }
  .backend img {
    width: 20vw !important;
  }
  .database img {
    width: 13vw !important;
  }
  .small-image img {
    width: 16vw !important;
  }
}
</style>
